import APIController from '../core-api-controller';

//Products Listing API's

export const fetchProductsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/products${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchProductVariantsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/product_variants${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const searchProductVariantsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/product_variants/search_product_variants${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const syncProductsApi = () => {
  const path = `${APIController.endpointApi}/products/sync`;
  return APIController.postCallback(path);
};

export const editProductsApi = (productId = '', data = {}, signal = null) => {
  const path = `${APIController.endpointApi}/products/${productId}`;
  return APIController.putCallback(path, data, null, signal);
};

export const createProuctsApi = (data = {}) => {
  const path = `${APIController.endpointApi}/products`;
  return APIController.postCallback(path, data);
};

export const fetchProductDetailApi = (productId = '') => {
  const path = `${APIController.endpointApi}/products/${productId}`;
  return APIController.getApiCallback(path);
};

export const fetchInternalProductsApi = (paramsObj = {}) => {
  const path = `${APIController.endpointApi}/client_user/products`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchAvailableProductVariantsApi = (paramsObj = {}) => {
  const path = `${APIController.endpointApi}/available_product_variants`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createAvailableProductVariantApi = (paramsObj = {}) => {
  const path = `${APIController.endpointApi}/available_product_variants`;
  return APIController.postCallback(path, paramsObj);
};

export const removeAvailableProductVariantApi = (productId = '') => {
  const path = `${APIController.endpointApi}/available_product_variants/${productId}`;
  return APIController.deleteCallback(path);
};
